import { encryptObject } from "@/helpers/noncehelper";
import { useLogin } from "@/helpers/useCommonFunctions";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "@dxp-feed/ui/Dialog";
import { Text } from "@dxp-feed/ui/Text";
import { usePathname } from "next/navigation";
import { setCookieWithExpiry } from "@/helpers/useCommonFunctions";
import { recipeModalData } from "@/utils/aemDefaultData";

interface LoginModalProps {
  isModalOpen: boolean;
  closeModal: () => void;
  label: string;
  recipeId?: any;
}

const LoginModal = ({
  isModalOpen,
  label,
  closeModal,
  recipeId,
}: LoginModalProps) => {
  const { loadLogin } = useLogin();
  const { aemRecipeModelData: aemModalData } = useAppSelector(
    (state) => state.AemModalSlice
  );

  return (
    <Dialog
      isOpen={isModalOpen}
      onClose={closeModal}
      className="max-w-[90%] xs:max-w-[432px] md:max-w-[357px] lg:max-w-[464px] xs:min-w-[432px] md:min-w-[357px] lg:min-w-[464px] py-4 px-6 outline-none"
    >
      <DialogHeader className="flex justify-between">
        <Text as="h2" className="font-bold">
          {aemModalData?.loginHeaderTitle ?? recipeModalData[0]?.loginHeaderTitle}
        </Text>
        <Button
          className="text-brandBlack font-bold text-lg"
          onClick={closeModal}
          aria-label="Close modal"
          variant="icon"
          size="none"
        >
          <span className="demo-icon icon-close text-brandBlack text-[14px]"></span>
        </Button>
      </DialogHeader>
      <DialogBody className="">
        <Text>
          <Text as="p" className="text-[14px]">
            {aemModalData?.loginBodyTitle ?? recipeModalData[0]?.loginBodyTitle}
          </Text>
          <Text
            as="ul"
            className="[&>li]:text-[14px] [&>li]:list-disc [&>li]:marker:text-sm pl-4"
          >
            {(aemModalData?.loginPoints ?? recipeModalData[0]?.loginPoints)?.map((point, _index) => (
              <Text key={point} as="li">
                {point}
              </Text>
            ))}
          </Text>
        </Text>
      </DialogBody>
      <DialogFooter className="flex flex-col justify-center ">
        <Box as="div" className="font-normal flex justify-end">
          <Button
            variant="primary"
            className="h-[40px] text-[14px] font-normal bg-brandPrimary 
            border-brandPrimary focus:bg-brandPrimary hover:bg-brandPrimary hover:border-brandPrimary focus:border-brandPrimary focus:text-brandPrimary hover:text-brandPrimary"
            onClick={() => {
              if (recipeId) {
                setCookieWithExpiry("susfvd", recipeId);
              }
              loadLogin("login");
            }}
            aria-label={aemModalData?.loginButton ?? recipeModalData[0]?.loginButton}
          >
            {aemModalData?.loginButton ?? recipeModalData[0]?.loginButton}
          </Button>
        </Box>
      </DialogFooter>
    </Dialog>
  );
};

export default LoginModal;